module.exports = "<button class=\"btn btn-outline-black\" type=\"submit\">\r\n{{label}}</button>"